export const profileQuery = (profile) => (dispatch) => {
	dispatch({ type: "UPDATE_SUCCESS", payload: profile });
};
